import './PlayerSelected.css';
import React from 'react';
import { getImgSrc } from '../../helpers/getImageSrc';

const PlayerSelected = ({ player }) => {
    return (
        <div className="player-selected-container">
            {/* Photo */}
            <div className={`ps-photo-wrap${player.img && player.img.includes('transfermarkt') ? ' ps-photo-wrap--tm' : ''}`}>
                {player.img ? (
                    <img
                        className={`ps-photo${player.img.includes('transfermarkt') ? ' ps-photo--tm' : ''}`}
                        src={getImgSrc(player.img)}
                        alt={player.nombre}
                        onError={e => { e.target.style.display = 'none'; }}
                    />
                ) : (
                    <div className="ps-photo-placeholder">
                        <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z"/>
                        </svg>
                    </div>
                )}
            </div>

            {/* Info */}
            <div className="ps-info">
                <span className="ps-label">Selected</span>
                <span className="ps-name">{player.nombre}</span>
                {(player.img_pais || player.pais) && (
                    <div className="ps-country">
                        {player.img_pais && (
                            <img className="ps-flag" src={player.img_pais} alt={player.pais || ''} />
                        )}
                        {player.pais && <span className="ps-country-name">{player.pais}</span>}
                    </div>
                )}
            </div>
        </div>
    );
};

export default PlayerSelected;
